"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startTrial = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _auth = require("hub-http/auth");

var startTrial = function startTrial(trialId, endDate, trialSource) {
  return _apiClient.default.post("/self-service/v2/trials/start?trialId=" + trialId + "&endDate=" + endDate + "&trialSource=" + trialSource).then(function () {
    return (0, _auth.refreshCookie)(_hubspot.default.get(), true);
  }).then(function () {
    return _apiClient.default.delete('/navconfig/v2/navconfig/cache');
  });
};

exports.startTrial = startTrial;